import { FileIcon } from "components/design/FileIcon";
import { CrossIcon } from "components/icons/CrossIcon";
import { UploadFromSelectorModal } from "components/UploadFromSelectorModal/UploadFromSelectorModal";
import { FileType } from "components/FileInput/FileInput";
import { filesToStagedDocs, StagedDocument } from "./ChatRequestAnswer";

import { Button } from "components/DesignSystem/Button/Button";

type RequestDocumentUploadProps = {
  docs: StagedDocument[];
  onDocsChange: (docs: StagedDocument[]) => void;
  groupId: string;
};

export const RequestDocumentUpload = ({
  docs,
  onDocsChange,
  groupId,
}: RequestDocumentUploadProps) => {
  const handleDrop = (files: FileType[]) => {
    onDocsChange([...docs, ...filesToStagedDocs(files)]);
  };

  const handleRemove = (id: string) => {
    onDocsChange(docs.filter((d) => d.id !== id));
  };

  return (
    <div className="t-flex t-flex-col t-gap-4">
      <UploadFromSelectorModal
        isOpen={false}
        close={() => {}}
        onDrop={handleDrop}
        groupId={groupId}
        allowSingleUpload={false}
        withModal={false}
        block
      />

      {docs.length > 0 && (
        <div className="t-flex t-flex-wrap t-gap-2">
          {docs.map((doc) => (
            <div
              key={doc.id}
              className="t-flex t-items-center t-gap-1.5 t-px-2 t-py-1 t-rounded-md t-border t-border-solid t-border-neutral-10 t-bg-surface t-text-body-sm t-text-text-60"
            >
              <FileIcon
                fileType={doc.fileType}
                size="16"
                className="t-shrink-0"
              />
              <span className="t-truncate t-max-w-48">{doc.name}</span>
              <Button
                customType="ghost_icon"
                size="small"
                onClick={() => handleRemove(doc.id)}
              >
                <CrossIcon className="t-size-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
